import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics"; // <-- El espía

const firebaseConfig = {
  apiKey: "AIzaSyA00gD-lESlDe-v3Jni_3GoIaEKF20EXus",
  authDomain: "acaargentina.firebaseapp.com",
  projectId: "acaargentina",
  storageBucket: "acaargentina.firebasestorage.app",
  messagingSenderId: "173875085463",
  appId: "1:173875085463:web:c2245bf16ad4560b21a9d2",
  measurementId: "G-J02QV2PFL4"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app); // <-- Espía activado